<template>
  <BContainer
    class="px-0"
    fluid
  >
    <BSkeletonWrapper
      :loading="loading"
    >
      <template #loading>
        <div
          class="iq-card lead-profile mb-0 shadow-none border"
        >
          <div class="iq-card-body profile-page p-0">
            <div class="profile-header p-4">
              <div class="profile-info">
                <div class="row">
                  <div class="col-12">
                    <div class="user-details pl-md-3">
                      <div class="d-flex flex-column flex-md-row justify-content-center justify-content-md-start align-items-center">
                        <div class="profile-img mb-3 mb-md-0">
                          <div class="profile-overlay-container">
                            <BSkeleton
                              type="avatar"
                              size="130px"
                              variant="primary"
                            />
                          </div>
                        </div>
                        <div class="d-flex flex-column align-items-center align-items-md-start pl-md-3">
                          <BSkeleton
                            width="260px"
                            height="25px"
                          />
                          <BSkeleton width="50px" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="col-12 col-md-6" /> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <div
        class="iq-card lead-profile mb-0 shadow-none border"
      >
        <div class="iq-card-body profile-page p-0">
          <div class="profile-header p-4">
            <div class="profile-info">
              <div class="row">
                <div class="col-12">
                  <div class="user-details pl-md-3">
                    <div class="d-flex flex-column flex-md-row justify-content-center justify-content-md-start align-items-center">
                      <div class="profile-img mb-3 mb-md-0">
                        <div class="profile-overlay-container">
                          <div @click.prevent="showModalProfile">
                            <BAvatar
                              variant="primary"
                              size="130px"
                              :text="String(lead.lead_name).charAt(0) + String(lead.lead_name).charAt(1)"
                            />
                          </div>
                          <!-- <div class="profile-overlay-middle">
                            <BButton
                              class="py"
                              style="border-radius: 50%;"
                              variant="dark"
                              :disabled="state.busy"
                              @click.prevent="editPicture"
                            >
                              <i
                                class="fad fa-camera p-0"
                                style="font-size: 12px;"
                              />
                            </BButton>
                          </div> -->
                        </div>
                      </div>
                      <div class="d-flex flex-column align-items-center align-items-md-start pl-md-3">
                        <h5 class="text-capitalize min-w-260px">
                          {{ lead.lead_name }}
                        </h5>
                        <p class="m-0">
                          Lead
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div class="col-12 col-md-6" /> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </BSkeletonWrapper>

    <BModal
      ref="modalPicture"
      scrollable
      centered
      hide-header
      no-close-on-esc
      no-enforce-focus
      no-close-on-backdrop
      content-class="w-md-350px"
      modal-class="full-height"
      aria-hidden="false"
      role="dialog"
    >
      <ValidationObserver
        ref="formPicture"
      >
        <form
          role="form"
          novalidate
          @submit.prevent
        >
          <div
            class="d-flex justify-content-center align-items-center pt-2"
          >
            <ValidationProvider
              v-slot="{ errors }"
              vid="file"
              name="photo"
              rules="required|image"
            >
              <BFormGroup
                label="Upload Profile"
                label-for="fUploadProfile"
                label-class="font-weight-bolder"
                class="mb-2"
              >
                <BFormFile
                  id="fUploadProfile"
                  v-model="formPicture.photo"
                  placeholder="Choose a profile..."
                  drop-placeholder="Drop file here..."
                  accept=".jpg,.jpeg,.png"
                  style="width: 300px;"
                  :state="errors.length > 0 ? false : null"
                  :disabled="state.busy"
                  @change="convertPicture"
                />
                <div
                  v-if="(errors.length > 0)"
                  class="invalid-feedback"
                  v-text="errors[0]"
                />
              </BFormGroup>
            </ValidationProvider>
          </div>
          <div
            class="d-flex justify-content-center align-items-center pt-3"
            style="min-height: 325px;"
          >
            <div class="cropper-container">
              <cropper-canvas
                ref="cropperCanvas"
                style="height: 300px; width: 300px;"
                class="border border-primary rounded"
              >
                <cropper-image
                  v-if="formPicture.file"
                  ref="cropperImage"
                  alt="Picture"
                  rotatable
                  scalable
                  skewable
                  translatable
                  :src="formPicture.file"
                />
                <cropper-selection
                  ref="cropperSelection"
                  x="10"
                  y="10"
                  multiple
                  keyboard
                  width="280"
                  height="280"
                  aspect-ratio="1"
                  style="border-radius: 50%; border: 2px dashed white !important;"
                >
                  <cropper-grid
                    role="grid"
                    covered
                    rows="0"
                    columns="0"
                  />
                  <cropper-crosshair
                    centered
                    theme-color="#ffffff"
                  />
                  <cropper-handle
                    action="move"
                    theme-color="rgba(255, 255, 255, 0)"
                  />
                </cropper-selection>
              </cropper-canvas>
            </div>
          </div>
        </form>
      </ValidationObserver>
      <template #modal-footer="{ cancel }">
        <BButton
          variant="primary"
          :disabled="state.busy"
          @click.prevent="validatePicture"
        >
          Change Profile
        </BButton>
        <BButton

          variant="outline-dark"
          :disabled="state.busy"
          @click.prevent="discardBtnEvent => preventAriaHidden(discardBtnEvent, cancel)"
        >
          Discard
        </BButton>
      </template>
    </BModal>

    <BModal
      ref="modalProfile"
      size="xl"
      scrollable
      hide-header
      no-close-on-backdrop
      modal-class="full-screen"
    >
      <div
        class="d-flex justify-content-center align-items-center"
        style="min-height: calc(100vh - 85px);"
      >
        <panZoom
          :options="{
            minZoom: 0.5,
            maxZoom: 5,
            bounds: true,
            boundsPadding: 0.5
          }"
        >
          <BImg
            class="d-blocks"
            :src="cProfilePath"
          />
        </panZoom>
      </div>
      <template #modal-footer="{ cancel }">
        <div class="col-12 d-flex justify-content-between px-0 pb-0 mb-0">
          <div />
          <div>
            <BButton
              variant="outline-dark"
              @click.prevent="discardBtnEvent => preventAriaHidden(discardBtnEvent, cancel)"
            >
              Close <span class="d-none d-md-inline-block">Preview</span>
            </BButton>
          </div>
        </div>
      </template>
    </BModal>
  </BContainer>
</template>
<script>
import 'cropperjs'
import QUERY from 'lodash'

import MxMisc from '@/mixins/misc'

import { SFSOLeadPhoto } from '@/services/fso'

export default {
  name: 'VFSOLeadProfilePictures',

  mixins: [
    MxMisc
  ],

  props: {
    loading: {
      type: Boolean,
      default: () => false
    },

    lead: {
      type: Object,
      required: true,
      default: () => ({
        id: ''
      })
    }
  },

  emits: ['updated'],

  data () {
    return {
      state: {
        busy: false
      },
      formProfile: {
        id: '',
        lead_id: this.lead.id,
        attachment_path: '',
        file_name: '',
        created_at: '',
        updated_at: ''
      },
      formPicture: {
        photo: null,
        file: ''
      }
    }
  },

  computed: {
    cProfilePath () {
      const leadPhoto = QUERY.first(this.lead.photos)
      if (leadPhoto) {
        return `${process.env.VUE_APP_API_BASE_URL}/${leadPhoto.attachment_path}/${leadPhoto.file_name}`
      }

      return `${window.location.origin}/img/invalid-image.png`
    }
  },

  methods: {

    showModalProfile () {
      if (this.lead.photos.length <= 0) {
        return
      }

      this.$refs.modalProfile.show()
    },

    convertPicture ({ target }) {
      if (target.files.length === 0) {
        this.formPicture.file = ''
        return
      }

      this.formPicture.file = URL.createObjectURL(target.files[0])
    },

    editPicture () {
      this.formPicture.file = ''

      this.$refs.modalPicture.show()

      this.$refs.modalPicture.onAfterEnter = () => {
        this.$refs.cropperSelection.$center()
      }
    },

    validatePicture () {
      this.$refs.formPicture.validate().then(
        validPicture => {
          if (!validPicture) {
            return this.swalInvalid()
          }

          this.swalConfirm({
            html: 'Change Profile of this Lead?',
            confirmButtonText: 'Change Profile',
            cancelButtonText: 'Discard',
            preConfirm: async () => {
              this.state.busy = true

              const createOrUpdate = async () => {
                return this.postPicture()
              }

              return createOrUpdate().catch(
                ({ message }) => {
                  if (message && message?.errors) {
                    this.$refs.formInteraction.setErrors(message.errors)
                  }
                }
              ).finally(() => {
                this.state.busy = false
              })
            }
          })
        }
      )
    },

    postPicture () {
      return new Promise((resolve, reject) => {
        this.$refs.cropperCanvas.$toCanvas().then(
          canvas => {
            const payload = new FormData()
            payload.append('lead_id', this.lead.id)

            canvas.toBlob(
              fileBlob => {
                payload.append('file', fileBlob, 'profile.png')

                SFSOLeadPhoto.post(payload).then(
                  ({ data: { message, lead_photo: leadProfile } }) => {
                    this.formProfile = Object.assign(this.formProfile, {
                      id: leadProfile.id,
                      lead_id: leadProfile.lead_id,
                      attachment_path: leadProfile.attachment_path,
                      file_name: leadProfile.file_name,
                      created_at: leadProfile.created_at,
                      updated_at: leadProfile.updated_at
                    })
                    this.swalSuccess(message).then(() => {
                      this.$refs.modalPicture.hide()
                      this.$emit('updated', Object.assign(this.formProfile, {
                        active: 1,
                        deleted_at: null
                      }))
                    })
                    resolve(message)
                  }
                ).catch(reject)
              },
              'image/png'
            )
          }
        )
      })
    }

  }

}
</script>
<style lang="scss">
  .profile-overlay-container {
    position: relative;
    width: 100%;
  }

  .profile-overlay-middle {
    bottom: 0;
    right: 0;
    position: absolute;
  }
</style>
